export function getCORSSafeURL(url: string) {
  try {
    const urlObj = new URL(url);
    return `${window.location.origin}${urlObj.pathname}`;
  } catch {
    return url;
  }
}

export const IMAGE_ASSETS_DIR = "/assets/images";
export const imageAssetUrl = (path: string) =>
  `${IMAGE_ASSETS_DIR}${path.startsWith("/") ? path : `/${path}`}`;
